import { Form, FormField } from '@/Core/UI/Form'
import { FormRow, FormSection } from '@/Ship/Components/Form/FormSection'

/**
 * Картка ТЗ стандартної ширини (560): до 3 коротких полів у рядку, числа (маса, габарити) —
 * парами; «Рік випуску» й «Ідентифікатор Wialon» — в ідентифікації поряд із держномером, VIN — окремим рядком.
 */
export const VehicleFormTemplate = ({ formContext }: any) => {
    return (
        <Form formContext={formContext}>
            {/* Ідентифікація */}
            <FormSection title="Ідентифікація">
                <FormRow>
                    <FormField name="brand" />
                    <FormField name="model" />
                    <FormField name="modelCode" />
                </FormRow>
                <FormRow>
                    <FormField name="registrationNumber" />
                    <FormField name="yearOfManufacture" />
                    <FormField name="wialonId" />
                </FormRow>
                {/* 17 символів — окремим рядком: у третину ширини картки не вміщується */}
                <FormField name="vin" />
            </FormSection>

            {/* Маса та габарити */}
            <FormSection title="Маса та габарити">
                <FormRow>
                    <FormField name="weightTariffKg" />
                    <FormField name="weightEmptyKg" />
                </FormRow>
                <FormRow>
                    <FormField name="weightWithCargoKg" />
                    <FormField name="lengthMm" />
                </FormRow>
                <FormRow>
                    <FormField name="widthMm" />
                    <FormField name="heightMm" />
                </FormRow>
            </FormSection>

            {/* Класифікація */}
            <FormSection title="Класифікація">
                <FormRow>
                    <FormField name="vehicleType" />
                    <FormField name="vehicleKind" />
                </FormRow>
                <FormRow>
                    <FormField name="carrier" />
                    <FormField name="driver" />
                </FormRow>
                {/* <FormField name="trailer" /> */}
            </FormSection>

            {/* Налаштування */}
            <FormSection title="Налаштування">
                <FormRow>
                    <FormField name="isActive" />
                    <FormField name="isAutoDecommission" />
                </FormRow>
                <FormRow>
                    <FormField name="isAdBlue" />
                    <FormField name="isHiredTransport" />
                </FormRow>
            </FormSection>

            {/* Системні поля */}
            <FormSection title="Системні поля">
                <FormRow>
                    <FormField name="externalCode" />
                    <FormField name="sorting" />
                </FormRow>
            </FormSection>
        </Form>
    )
}
